import type { Page } from '../../types';

const minStandardCorporate: Page[] = [
  {
    pageType: 'question',
    title: 'Minimum Standards',
    name: 'minimum-standards',
    hidePageTitle: true,
    description:
      'A conversation must take place at the start of the year between you and your Line Manager to agree how these standards will be demonstrated in a way that is relevant to your role. You should agree how you will determine whether you have \'met\' these standards. The standards can be found here <a href="https://www.gov.uk/government/publications/senior-civil-service-performance-management" target="_blank" rel="noopener noreferrer">gov.uk</a>. Line Managers will make judgements on whether standards have been met as part of their validation.<br><br>Please complete the box below on how you have met each of the Minimum Standards. Please refer to evidence captured throughout the performance year<br><br>',
    questions: [
      {
        questionType: 'textarea',
        textRows: 20,
        title: 'Corporate',
        name: 'minimum-standard-corporate',
        detailsHeading: 'More information',
        detailsContent: `The minimum Corporate standards require all SCS to:<br><ul>
  <li>Lead the Civil Service by contributing to its collective running, performance, culture and reputation, beyond their business unit and immediate responsibilities.</li>
  <li>Actively deliver organisation-wide and/or gross government initiatives by embedding them into their work and enabling teams to understand and contribute to these.</li>
  <li>Activity that goes above and beyond the day to day role. Impact should be seen at departmental level and reach beyond the boundaries of your business unit.</li>
</ul>`,
        hint: `How will this be demonstrated in my role?  
  Each SCS member is expected to undertake an activity that goes above and beyond the day-to-day role.  SCS should contribute to its collective running, performance, culture and reputation, beyond their business unit and immediate responsibilities.  Actively deliver organisation-wide and/or cross government initiatives by embedding them into their work and enabling teams to understand and contribute to these.`,
        wordCount: 250,
        rules: {
          required: true,
        },
      },
      {
        questionType: 'select',
        title: 'What was the reach of your actions during this reporting period?',
        name: 'person-details-reach',
        options: [
          'Within Business Unit',
          'Cross‑Directorate (within Cabinet Office)',
          'Cross‑Department (across government departments)',
          'Civil Service‑wide',
        ],
        rules: {
          required: true,
        },
      },
    ],
  },
];

export default minStandardCorporate;
